module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-tile-3-large-0ac507829f96aca77f9700a7faf66c64.jpg";